import {
  Box,
  Button,
  Link,
  Typography,
  // Paper
} from "@mui/material";

import Logo from "../assets/JudoSV_logo.png";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();
  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: "auto",
        p: 0,
        mt: 0,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          py: 4,
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontWeight: "bold",
            mb: 2,
            fontSize: {
              xs: "1.5rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          Bienvenue sur le site d'inscription
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          gutterBottom
        >
          Open International de Sambreville
        </Typography>

        <Box
          component="img"
          src={Logo}
          alt="Logo Judo Club Sambreville"
          sx={{
            display: "block",
            mx: "auto",
            my: 4,
            width: {
              xs: 180, // mobile
              sm: 200, // tablette
              md: 250, // desktop
            },
            maxWidth: "100%",
          }}
        />

        <Typography variant="h4" gutterBottom>
          <Button
            variant="outlined"
            component={Link}
            onClick={() => navigate("/registration")}
            target="_blank"
          >
            S'inscrire à l'Open
          </Button>

        </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: 600,
            mx: "auto",
          }}
        >
          Bienvenue sur la plateforme officielle de l'Open International de Sambreville.<br />
          Vous pouvez consulter les informations du tournoi,
          gérer les inscriptions des judokas et effectuer le
          check-in avant la compétition.
        </Typography>
      </Box>
    </Box>
  );
};

export default Home;